/**
 * Returns the root domain (origin) of a URL, e.g. "https://example.com" from "https://example.com/path".
 * Returns empty string if URL is invalid or empty.
 */
export function getRootDomain(url) {
  if (!url || typeof url !== 'string' || url.trim() === '' || url === 'https://') return '';
  try {
    const href = url.trim().startsWith('http') ? url.trim() : `https://${url.trim()}`;
    const u = new URL(href);
    return u.origin;
  } catch {
    return '';
  }
}

/** Default base URLs for social fields so user can type their profile after it (like website's https://) */
export const SOCIAL_PLATFORM_BASES = {
  facebook: 'https://facebook.com/',
  instagram: 'https://instagram.com/',
  pinterest: 'https://pinterest.com/'
};

/** True if value is only the platform base URL with no user path (do not send/show). */
export function isOnlyPlatformBaseUrl(value, platform) {
  const base = SOCIAL_PLATFORM_BASES[platform];
  if (!value || typeof value !== 'string' || !base) return true;
  const v = value.trim();
  if (v === '') return true;
  const baseNorm = base.replace(/\/+$/, '');
  const valueNorm = v.replace(/\/+$/, '');
  return valueNorm === baseNorm;
}
